import { render } from "./EditUserAdmin.vue?vue&type=template&id=3f5fcc39"
import script from "./EditUserAdmin.vue?vue&type=script&lang=js"
export * from "./EditUserAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__